export class Pako {
    private _pako?:any;

    constructor() {
        if (window['pako']) {
            this._pako = window['pako'];
        }
    }
    gzip(data:string) : Uint8Array {
        if (this._pako) {
            return this._pako.gzip(data);
        }
        
        throw new Error("Pako service not available");
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/pako.service.ts